import './ApuracaoIcms.scss'
import React, { useState, useContext, useReducer, useMemo } from 'react'
import { GlobalContext } from 'globalContext'
import { useSubscription } from 'utils'
import PageHeader from 'components/PageHeader'
import PageLoader from 'components/PageLoader'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { Segment, Header, Icon, Button } from 'semantic-ui-react'
import ConferirForm from './ConferirForm'
import Demonstrativo from './Demonstrativo'
import ConfrontarForm from './ConfrontarForm'
import ConfrontoProdac from './ConfrontoProdac'

function reducer(state, action) {
    switch(action.type) {
        case 'setForm':
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export default function ApuracaoIcms() {

    const [globalState] = useContext(GlobalContext)
    const [acao, setAcao] = useState('conferir')
    const [apuracao, setApuracao] = useState(null)
    const [confronto, setConfronto] = useState(null)
    const [isFetching, setIsFetching] = useState(true)
    const [periodos, setPeriodos] = useState([])
    const [form, dispatch] = useReducer(reducer, {
        empresa: '',
        periodo: '',
        periodType: 1,
        dataIni: '',
        dataFim: '',
        splitByMonth: false
    })
    
    function clearState() {
        setApuracao(null)
        setConfronto(null)
        dispatch({ type: 'setForm', payload: { empresa: '', periodo: '', splitByMonth: false, periodType: 1, dataIni: '', dataFim: '' }})
    }
    
    const getPeriodos$ = useMemo(() => request({ url: '/common/dre/periodos', method: 'GET' }).pipe(
        tap(({ response }) => setPeriodos(response.periodos)),
        finalize(() => setIsFetching(false))
    ), [])
    
    useSubscription(getPeriodos$, isFetching && globalState.empresas !== null)
    
    const formProps = { empresas: globalState.empresas, periodos, form, dispatch, setApuracao, setConfronto }
    const demonstrativoProps = { empresas: globalState.empresas, periodos, form, apuracao, setApuracao, clearState }
    const comparativoProps = { confronto, clearState }

    return (
        <PageLoader active={globalState.empresas === null}>
            <div id="apuracao-icms" className='page-content'>          

                <PageHeader />

                {!apuracao && !confronto && <Segment className='subcontent'>
                    <div className="row flex-grow-1">
                        <div className="col d-flex flex-column">
                            <div className="row mx-0">
                                <div className="col">
                                    <Header as='h3'>
                                        <Icon.Group size='big'>
                                            <Icon name='tasks' className='primary-color' />
                                        </Icon.Group>
                                        <Header.Content className='primary-color'>
                                            Ações 
                                            <Header.Subheader className='secondary-color'><strong>Escolha a ação desejada</strong></Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                </div>
                            </div>
                            <div className="row flex-grow-1 flex-column">
                                <div className="col d-flex align-items-center flex-column justify-content-center">
                                    <Button icon className='w-50 btn-primary mt-2' color='blue' onClick={() => setAcao('conferir')} size='small' fluid>
                                        <Icon name='clipboard list' /> Apuração
                                    </Button>
                                    <Button icon className='w-50 btn-primary mt-2' color='blue' onClick={() => setAcao('confrontar')} size='small' fluid>
                                        <Icon name='clipboard list' /> Confrontar c/ Prodac
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {acao === 'conferir' && <div className="col d-flex flex-column flex-grow-1">
                            <Header as='h3'>
                                <Icon.Group size='big'>
                                    <Icon name='clipboard list' className='primary-color' />    
                                </Icon.Group>
                                <Header.Content className='primary-color'>
                                    Apuração
                                    <Header.Subheader className='secondary-color'>
                                        <strong>Consolidar dados para DRE</strong>
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>
                            <div className='d-flex flex-column flex-grow-1 align-items-center justify-content-center'>
                                <ConferirForm {...formProps} />
                            </div>
                        </div>}
                        {acao === 'confrontar' && <div className="col d-flex flex-column flex-grow-1">
                            <Header as='h3'>
                                <Icon.Group size='big'>
                                    <Icon name='clipboard list' className='primary-color' />    
                                </Icon.Group>
                                <Header.Content className='primary-color'>
                                    Confrontar com Prodac
                                    <Header.Subheader className='secondary-color'>
                                        <strong>Cruzar relatórios</strong>
                                    </Header.Subheader>
                                </Header.Content>
                            </Header>
                            <div className='d-flex flex-column flex-grow-1 align-items-center justify-content-center'>
                                <ConfrontarForm {...formProps} />
                            </div>
                        </div>}
                    </div>
                </Segment>}

                {apuracao && <Segment className='subcontent'>
                    <div className="row flex-grow-1">
                        <div className="d-print-inline-block col d-flex flex-column align-items-center">   
                            <Demonstrativo {...demonstrativoProps} />
                        </div>
                    </div>
                </Segment>}

                {confronto && <Segment className='subcontent'>
                    <div className="row flex-grow-1">
                        <div className="d-print-inline-block col d-flex flex-column align-items-center">   
                            <ConfrontoProdac {...comparativoProps} />
                        </div>
                    </div>
                </Segment>}
            </div>
        </PageLoader>
    )
}
